import Swal from 'sweetalert2'
import { v4 as uuid } from "uuid";
import { toast } from "react-toastify";
import { useContext } from 'react';
import RoleContext from '..';

const multiplePartUploadDetails = []
const chunkArray_data = [];
const failed_chunk = [];

const common = {
    escaping(value, action = null) {
        if (value) {
            value = value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            if (action) {
                value = value.replace(/["']/g, "\'");
            }
        }
        return value;
    },
    mailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    domainRegex: /^[A-Za-z0-9][A-Za-z0-9-]*$/,

    /**
     * 
     * @param {String} type 
     * @param {String} title 
     */
    toastMessage: (type, title) => {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
        Toast.fire({
            icon: type,
            title: common.capitalizeFirstLetter(title)
        });
    },

    /**
     * 
     * @param {Function} callback
     * @param {String} text
     * @param {String} confirmButtonText
     * @param {String} confirmedTitle
     * @param {String} confirmedText
     * @returns 
     */
    confirmationModal: ({ ...args }) => {
        let { callback, text, confirmButtonText, confirmedTitle, confirmedText, cancelButtonText } = args;

        Swal.fire({
            title: "Are you sure?",
            text: text || "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3c50e0",
            cancelButtonColor: "#d33",
            confirmButtonText: confirmButtonText || "Yes, delete it!",
            cancelButtonText: cancelButtonText || "Cancel",
        }).then((result) => {
            // if (result.isConfirmed) {
            //     Swal.fire({
            //         title: confirmedTitle || "Deleted!",
            //         text: confirmedText || "Your file has been deleted.",
            //         icon: "success",
            //         confirmButtonColor: "#1292FF"
            //     });
            // }
            callback(result, (value) => {
                if (value) {
                    Swal.fire({
                        title: confirmedTitle || "Deleted!",
                        text: confirmedText || "Your file has been deleted.",
                        icon: "success",
                        confirmButtonColor: "#3c50e0"
                    });
                }
            })
        });
    },
    isValidDate(date) {
        let newDate = new Date(date)
        return !isNaN(newDate.getTime())
    },
    product_id_regex: /^[-+]?[0-9]{1,3}(?:,?[0-9]{0,3})*(\.\d+)?$/,  // allowed only numbers with comma seperated
    product_handle_regex: /^[\p{L}\p{N}\s_,'-]+(?:-[\p{L}\p{N}]+)*$/u, ///^[a-zA-Z0-9,'-]+(?:,[a-zA-Z0-9,'-]+)*$/,    //allowed letters, numbers, commas, hyphens, and apostrophes

    async clickToCopy(value) {
        try {
            await navigator.clipboard.writeText(value);
            this.toastMessage('success', 'Text copied to clipboard successfully!');
        } catch (error) {
            this.toastMessage('warning', 'Error copying text to clipboard:', error);
        }
    },

    getLocalTimestamp(date = false) {
        let today = new Date();
        if (date) {
            date = new Date(date);
            if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getYear() === today.getYear()) {
                date = this.formatedDate(new Date(date), true),
                    date = date.replace(date.substr(0, 12), 'Today');
            } else {
                date = this.formatedDate(new Date(date), true)
            }
        } else
            date = this.formatedDate(new Date(date), true)
        return date;
    },

    formatedDate(date, second = false) {
        if (second)
            return new Date(date).toLocaleString('en-US', { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true })
        else
            return new Date(date).toLocaleString('en-US', { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })
    },

    getUID() {
        return uuid();
    },

    uploadFile: (file, role) => {
        return new Promise(async (resolve, reject) => {
            try {
                const formData = new FormData()
                formData.append('file', file)
                let response = await fetch(`/${role}/api/upload-file`, { method: 'POST', body: formData })
                response = await response.json()
                if (response.status == 1) {
                    resolve(response.url)
                } else {
                    reject(response.data)
                }
            } catch (err) {
                console.log(err)
                reject(err.toString())
            }
        })
    },

    deleteFile: (file_url, role) => {
        return new Promise(async (resolve, reject) => {
            try {
                let options = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ file_url: file_url })
                }
                let response = await fetch(`/${role}/api/delete-file`, options)
                response = response.json()
                if (response.status == 1) {
                    resolve(true)
                } else {
                    resolve(false)
                }
            } catch (err) {
                console.log(err)
                reject(err.toString())
            }
        })
    },

    eventStatusColor: {
        'upcoming': 'text-[#1292FF]',
        'live': 'text-[#31A940]',
        'recorded': 'text-[#D95951]',
        'expired': 'text-[#f21818]',
        'upcoming-bg': 'bg-[#1292FF]',
        'live-bg': 'bg-[#31A940]',
        'recorded-bg': 'bg-[#D95951]',
        'expired-bg': 'bg-[#f21818]'
    },

    getEventStatusClasses: (status, type = 'text') => {
        let color = type === 'bg' ? (status + '-' + type) : status;
        return `${common.eventStatusColor[color]}`;
    },

    createMultipartUpload: (fileName, fileType, role) => {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await fetch(`/${role}/api/create-multipart-upload`, { 
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({fileName: fileName, contentType: fileType})
                })
                response = await response.json()
                if (response.success) {
                    resolve(true)
                } else {
                    reject(response.message)
                }
            } catch (err) {
                console.log(err)
                reject(err.toString())
            }
        })
    },

    completeMultipartUpload: (role) => {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await fetch(`/${role}/api/complete-multipart-upload`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        parts: multiplePartUploadDetails
                    })
                })
                response = await response.json()
                if(response.success) {
                    resolve(response.data)
                } else 
                    reject(response.message)
            } catch (err) {
                console.log(err)
                reject(err.toString())
            }
        })
    },

    abortMultipartUpload: (role) => {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await fetch(`/${role}/api/abort-multipart-upload`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                response = await response.json()
                if(response.status == 1) {
                    resolve(true)
                } else 
                    reject(response.data)
            } catch (err) {
                console.log(err)
                reject(err.toString())
            }
        })
    },

    uploadChunk: (chunk, index, role, type= 1, setFileUploading) => {
        return new Promise(async (resolve, reject) => {
            try {
                const formData = new FormData()
                formData.append('file', chunk)
                formData.append('partNumber', index)
                let response = await fetch(`/${role}/api/upload-part`, {
                    method: 'POST',
                    headers: {
                        dataType: 'json'
                    },
                    body: formData
                })
                response = await response.json()
                if(response.success) {
                    const uploadPartDetails = {
                        ETag: response.data?.ETag,
                        PartNumber: index,
                    };
                    multiplePartUploadDetails.push(uploadPartDetails);
                    setFileUploading(5*1024*1024)
                    if(type == 2)
                        chunkArray_data[index-1].status = 2
                    resolve(true)
                } else {
                    if(type == 2) {
                        chunkArray_data[index-1].status = 1;
                        chunkArray_data[index-1].retry++;
                    }
                    reject(response.data)
                }
            } catch(err) {
                if(type == 2) {
                    chunkArray_data[index-1].status = 1;
                    chunkArray_data[index-1].retry++;
                }
                console.log(err)
                reject(err.toString())
            }
        })
    },

    multipartUpload: (file, role) => { // uploading file one by one part
        multiplePartUploadDetails.length = 0
        return new Promise(async (resolve, reject) => {
            try {
                const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
                const fileSize = file.size
                const totalChunks = Math.ceil(fileSize / CHUNK_SIZE);
                var MAX_TRY_UPLOAD = 0

                await common.createMultipartUpload(file.name, file.type, role);
                for(let i = 0; i < totalChunks; i++) {
                    const start = i*CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, fileSize);
                    const chunk = file.slice(start, end);
                    try {
                        await common.uploadChunk(chunk, i + 1, role, 1);
                        MAX_TRY_UPLOAD = 0
                    } catch(e) {
                        if(MAX_TRY_UPLOAD == 4) {
                            throw('Maximum upload attempt exceeded')
                        }
                        i = i-1;
                        if(navigator.onLine) {
                            await common.waitForReUpload()
                            MAX_TRY_UPLOAD++;
                        } else {
                            await common.waitForInternetRestore()
                        }
                    }
                }
                let url = await common.completeMultipartUpload(role)
                resolve(url)
            } catch(err) {
                console.log(err)
                await common.waitForInternetRestore()
                common.abortMultipartUpload(role)
                reject(err.toString())
            } finally {
                multiplePartUploadDetails.length = 0
            }
        });
    },

    multipartUploadSync: (file, role, setFileUploading) => { // upload file in batch form (4 parts concurrently upload in parallel)
        multiplePartUploadDetails.length = 0
        chunkArray_data.length = 0
        return new Promise(async (resolve, reject) => {
            try {
                const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
                const fileSize = file.size
                const totalChunks = Math.ceil(fileSize / CHUNK_SIZE);
                console.log('total chunks: ' + totalChunks)

                await common.createMultipartUpload(file.name, file.type, role);

                for(let i = 0; i < totalChunks; i++) {
                    const start = i*CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, fileSize);
                    const chunk = file.slice(start, end);
                    chunkArray_data.push({blob: chunk, index: i+1, status: 0, retry: 0})
                }

                let paralle_response = await common.uploadChunksInPrallel(role, setFileUploading);

                let url = await common.completeMultipartUpload(role)
                resolve(url)
            } catch(err) {
                console.log(err)
                await common.waitForInternetRestore()
                common.abortMultipartUpload(role)
                reject(err.toString())
            } finally {
                multiplePartUploadDetails.length = 0
                chunkArray_data.length = 0
            }
        })
    },

    uploadChunksInPrallel: (role, setFileUploading) => {
        const concurrency_limit = 1;
        const uploadPromsie = [];
        return new Promise(async (resolve, reject) => {
            try {
                let is_Retry_exceed = chunkArray_data.some(chunk => chunk.retry > 5)
                if(is_Retry_exceed) {
                    reject('maximum upload attempts exceeded')
                    return ;
                }
                
                let pending_chunk = chunkArray_data.some(chunk => chunk.status != 2 )
                if(!pending_chunk) {
                    console.log('No more pending chunks, resolve promise')
                    resolve(true);
                    return ;
                }
    
                let uploading_chunk_index = []
                for(let i= 0; i< concurrency_limit; i++) {
                    const pending_chunk_index = chunkArray_data.findIndex(chunk => chunk.status!= 2 && !uploading_chunk_index.includes(chunk.index))
                    if(pending_chunk_index == -1) break;
    
                    uploading_chunk_index.push(chunkArray_data[pending_chunk_index].index)
    
                    uploadPromsie.push(common.uploadChunk(chunkArray_data[pending_chunk_index].blob, chunkArray_data[pending_chunk_index].index, role, 2, setFileUploading))
                }
                
                let response = await Promise.allSettled(uploadPromsie)
                let is_any_rejected = response.some(value => value.status !== "fulfilled")
                if(is_any_rejected) {
                    if(navigator.onLine) {
                        await common.waitForReUpload()
                    } else {
                        await common.waitForInternetRestore()
                    }
                }

                return common.uploadChunksInPrallel(role, setFileUploading).then(resolve).catch(reject)
            } catch(err) {
                console.log(err)
                reject(err.toString())
            }
        })
    },

    waitForInternetRestore: () => {
        return new Promise((resolve) => {
            if (navigator.onLine) {
              resolve();
            } else {
              // Listen for the online event
              const handleOnline = () => {
                console.log('restore intrernet connection... trying to upload...');
                window.removeEventListener('online', handleOnline);
                resolve();
              };
              window.addEventListener('online', handleOnline);
            }
        });
    },

    waitForReUpload: () => {
        console.log('wait 2 second for reuploading...');
        return new Promise(resolve => setTimeout(resolve, 2000)); // wait for 2 seconds
    },

    capitalizeFirstLetter: (string) => {
        if (!string) return string; 
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    loadScripts: (src) => {
        return new Promise((resolve, reject) => {
            if(document.querySelector(`script[src="${src}"]`)) {
                return resolve('script already loaded');
            }
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = () => {resolve('script loaded');};
            script.onerror = () => reject(new Error('Failed to load script'));
            document.body.appendChild(script);
        });
    },

    loadLink: (link) => {
        return new Promise((resolve, reject) => {
            if(document.querySelector(`link[href="${link}"]`)) {
                return resolve('link already loaded');
            }
            const linkElement = document.createElement('link');
            linkElement.rel ='stylesheet';
            linkElement.href = link;
            linkElement.onload = () => {resolve('link loaded');};
            linkElement.onerror = () => reject(new Error('Failed to load link'));
            document.head.appendChild(linkElement);
        });
    },

    getDisplayedVideoSize(videoEl) {
        const videoRatio = videoEl.videoWidth / videoEl.videoHeight;
        const containerRatio = videoEl.clientWidth / videoEl.clientHeight;

        let width, height, xOffset, yOffset;

        const objectFit = getComputedStyle(videoEl).objectFit || "contain";

        if (objectFit === "cover") {
            if (videoRatio > containerRatio) {
                height = videoEl.clientHeight;
                width = height * videoRatio;
                xOffset = (videoEl.clientWidth - width) / 2;
                yOffset = 0;
            } else {
                width = videoEl.clientWidth;
                height = width / videoRatio;
                xOffset = 0;
                yOffset = (videoEl.clientHeight - height) / 2;
            }
        } else {
            if (videoRatio > containerRatio) {
                // black bars top/bottom
                width = videoEl.clientWidth;
                height = width / videoRatio;
                xOffset = 0;
                yOffset = (videoEl.clientHeight - height) / 2;
            } else {
                // black bars left/right
                height = videoEl.clientHeight;
                width = height * videoRatio;
                xOffset = (videoEl.clientWidth - width) / 2;
                yOffset = 0;
            }
        }


        return { width, height, xOffset, yOffset };
    },

    throttle : (fn, limit) => {
        let isThrottle = false
        return (...args) => {
            if(!isThrottle) {
                fn(...args)
                isThrottle = true
                setTimeout(() => {isThrottle = false}, limit)
            }
        }
    },

    debounce: (fn, delay) => {
        let timer;
        return (...args) => {
            clearTimeout(timer)
            timer = setTimeout(() => fn(...args ), delay)
        }
    }
}

export default common;